export class CreateSessionRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sessionId",
            "baseName": "session_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "events",
            "baseName": "events",
            "type": "Array<{ [key: string]: any; }>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateSessionRequest.attributeTypeMap;
    }
    constructor() {
    }
}
